import { createContext, useContext } from "react";

const STORAGE_KEY = "orders360.vistaClasica";

export const readClassicView = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const saveClassicView = (classic: boolean) => {
  try {
    if (classic) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    return;
  }
};

export interface ClassicView {
  classic: boolean;
  setClassic: (classic: boolean) => void;
}

export const ClassicViewContext = createContext<ClassicView>({ classic: false, setClassic: () => undefined });

export const useClassicView = () => useContext(ClassicViewContext);
